import { loadStripe, type Stripe } from '@stripe/stripe-js';

let promise: Promise<Stripe | null> | null = null;
export function getStripe(): Promise<Stripe | null> {
  if (!promise) {
    promise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '');
  }
  return promise;
}
